import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useSearchParamsObject } from 'app/hooks';
// import { useRemoveLoginMutation } from 'services/exploreApi';
import Text from 'common/components/Text/Text';

import styles from './AppNavbar.module.scss';
import Loader from 'common/components/Loader/Loader';
import { Program, School, Subject } from 'app/types';
import { useGetProgramsQuery, useGetSchoolsQuery, useGetSubjectsQuery } from 'services/exploreApi';
import { newDetailUrl } from 'common/utils/conversions';
import defaultIcon from 'assets/explore/icon-default.svg';
import { useMediaQuery } from 'react-responsive';
import { setFilters } from 'features/session/sessionSlice';

interface CompProps {
  navigateTo: (route: string) => void;
}
interface Pagination {
  pages: number;
  current: number;
  total: number;
}

const defaultPage: Pagination = {
  pages: 0,
  current: 0,
  total: 0,
};

const SearchMenu = ({ navigateTo }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [searchFilters, setSearchFilters] = useState<{ [k: string]: any }>({
    query: '',
    search: true,
  });
  const [activeTopic, setActiveTopic] = useState<number>(0);
  const [itemsToShow, setItemsToShow] = useState<number>(0);
  const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);
  const [schoolPagination, setSchoolPagination] = useState<Pagination>(defaultPage);
  const [programPagination, setProgramPagination] = useState<Pagination>(defaultPage);
  const [subjectPagination, setSubjectPagination] = useState<Pagination>(defaultPage);
  const [searchParams] = useSearchParamsObject();
  const dispatch = useAppDispatch();

  // const [removeLogin] = useRemoveLoginMutation();
  const {
    data: schools,
    isLoading: schoolsLoading,
    isFetching: schoolsFetching,
  } = useGetSchoolsQuery({
    ...searchFilters,
    page: schoolPagination.current,
  });
  const {
    data: programs,
    isLoading: programsLoading,
    isFetching: programsFetching,
  } = useGetProgramsQuery({
    ...searchFilters,
    page: programPagination.current,
  });
  const {
    data: subjects,
    isLoading: subjectsLoading,
    isFetching: subjectsFetching,
  } = useGetSubjectsQuery({
    ...searchFilters,
    page: subjectPagination.current,
  });
  const onFilterTextInputChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.value = event.target.value.trimStart();
    onFilterChange(key, event.target.value);
  };
  const onFilterChange = (key: string, value: any) => {
    if (value === undefined || value === null || value === '') {
      setSearchFilters(({ [key]: _, ...rest }) => rest);
      dispatch(setFilters(({ [key]: _, ...rest }) => rest));
    } else {
      setSearchFilters((sf) => ({ ...sf, [key]: value }));
      dispatch(setFilters({ query: searchFilters['query'] }));
    }
  };
  const handleSubjectFilter = (subject_id: number) => {
    dispatch(setFilters({ subject_id: [subject_id] }));
    navigateTo('explore/programs');
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', handleWindowResize);
    setItemsToShow(Math.trunc(windowSize[1] / 130));
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });
  useEffect(() => {
    for (const [key, value] of Object.entries(searchParams)) {
      setSearchFilters((f) => ({ ...f, [key]: [Number(value)] }));
    }
  }, []);

  useEffect(() => {
    if (programs?.meta) setProgramPagination(programs.meta);
  }, [programs]);

  useEffect(() => {
    if (schools?.meta) setSchoolPagination(schools.meta);
  }, [schools]);

  useEffect(() => {
    if (subjects?.meta) setSubjectPagination(subjects.meta);
  }, [subjects]);

  return (
    <div className={styles.searchMenuContainer}>
      <div className={styles.search}>
        <i className="bi bi-search"></i>
        <input
          type="text"
          placeholder="Search for subjects, programs, schools..."
          value={searchFilters.query || ''}
          onChange={onFilterTextInputChange('query')}
        />
      </div>
      <div className={styles.topicContainer}>
        <div className={styles.topicTitles}>
          <div className={styles.topic}>
            <div
              className={`${styles.topicTitle} ${activeTopic === 0 ? styles.active : ''}`}
              onClick={() => setActiveTopic(0)}
            >
              <Text
                size={14}
                weight={activeTopic === 0 ? 700 : 500}
                inlineStyle={{ color: '#19234F' }}
              >
                Subjects
              </Text>
            </div>
          </div>
          <div className={styles.topic}>
            <div
              className={`${styles.topicTitle} ${activeTopic === 1 ? styles.active : ''}`}
              onClick={() => setActiveTopic(1)}
            >
              <Text
                size={14}
                weight={activeTopic === 1 ? 700 : 500}
                inlineStyle={{ color: '#19234F' }}
              >
                Programs
              </Text>
            </div>
          </div>
          <div className={styles.topic}>
            <div
              className={`${styles.topicTitle} ${activeTopic === 2 ? styles.active : ''}`}
              onClick={() => setActiveTopic(2)}
            >
              <Text
                size={14}
                weight={activeTopic === 2 ? 700 : 500}
                inlineStyle={{ color: '#19234F' }}
              >
                Schools
              </Text>
            </div>
          </div>
        </div>
        {activeTopic === 0 &&
          (subjectsLoading || subjectsFetching ? (
            <Loader />
          ) : (
            <div className={styles.topicList}>
              {subjects?.data.slice(0, itemsToShow).map((subject: Subject) => (
                <div
                  key={subject.id}
                  // className={styles.dropdownItem}
                  onClick={() => handleSubjectFilter(subject.id)}
                >
                  {/* <img className={styles.avatar} src={school.logo || defaultIcon} /> */}
                  <div className={styles.itemContainer}>
                    <i className="bi bi-journal-text"></i>
                    <div className={styles.itemInfo}>
                      <Text
                        size={16}
                        weight={600}
                        inlineStyle={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {subject.name}
                      </Text>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        {activeTopic === 1 &&
          (programsLoading || programsFetching ? (
            <Loader />
          ) : (
            <div className={styles.topicList}>
              {programs?.data.slice(0, itemsToShow).map((program: Program) => (
                <div
                  key={program.id}
                  // className={styles.dropdownItem}
                  onClick={() => navigateTo(newDetailUrl('programs', program.id, program.name))}
                >
                  {/* <img className={styles.avatar} src={school.logo || defaultIcon} /> */}
                  <div className={styles.itemContainer}>
                    <img className={styles.avatar} src={program.logo || defaultIcon} />
                    <div className={styles.itemInfo}>
                      <Text
                        size={14}
                        weight={500}
                        inlineStyle={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {program.name}
                      </Text>
                      <Text
                        size={12}
                        weight={500}
                        inlineStyle={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          color: '#727D9B',
                        }}
                      >
                        <i className="bi bi-geo-alt"></i>
                        {program.school_name}
                      </Text>
                    </div>
                  </div>
                </div>
              ))}
              <a href="/explore/programs" className={styles.indexButton}>
                See all
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          ))}
        {activeTopic === 2 &&
          (schoolsLoading || schoolsFetching ? (
            <Loader />
          ) : (
            <div className={styles.topicList}>
              {schools?.data.slice(0, itemsToShow).map((school: School) => (
                <div
                  key={school.id}
                  // className={styles.dropdownItem}
                  onClick={() => navigateTo(newDetailUrl('schools', school.id, school.name))}
                >
                  {/* <img className={styles.avatar} src={school.logo || defaultIcon} /> */}
                  <div className={styles.itemContainer}>
                    <img className={styles.avatar} src={school.logo || defaultIcon} />
                    <div className={styles.itemInfo}>
                      <Text
                        size={14}
                        weight={500}
                        inlineStyle={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {school.name}
                      </Text>
                      <Text
                        size={12}
                        weight={500}
                        inlineStyle={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          color: '#727D9B',
                          display: 'flex',
                          gap: '3px',
                        }}
                      >
                        <i className="bi bi-geo-alt"></i>
                        {school.city.name}, {school.city.country.name}
                      </Text>
                    </div>
                  </div>
                </div>
              ))}
              <a href="/explore" className={styles.indexButton}>
                See all
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          ))}
      </div>
    </div>
  );
};

export default SearchMenu;
